<ng-container *ngIf="isLoading">
  <div class="row text-center">
    <div class="col-2 offset-5 text-center">
      <mat-spinner></mat-spinner>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="!isLoading">
  <div class="row path">
    <div class="col-12">
      <mat-toolbar color="accent">
        <mat-toolbar-row>
          <mat-icon>folder</mat-icon>
          <span style="margin-left: 20px;">{{currentDirectory?.Name}}</span>
          <span class="fill-remaining-space"></span>

          <button (click)="getData()" mat-icon-button type="button">
            <mat-icon>refresh</mat-icon>
          </button>

          <button *ngIf="currentDirectory.Path" [matMenuTriggerFor]="moreMenu" mat-icon-button type="button">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #moreMenu="matMenu">
            <button (click)="openFolderEditor()" mat-menu-item
                    type="button">
              <mat-icon>create_new_folder</mat-icon>
              New folder
            </button>
            <button (click)="openFileUploader()" mat-menu-item type="button">
              <mat-icon>cloud_upload</mat-icon>
              Upload files
            </button>
            <button (confirm)="deleteFiles()" *ngIf="Checked.length > 0" appConfirmDialog mat-menu-item
                    message="Are you sure you want to permanently delete these files?"
                    title="Delete Files?" type="button">
              <mat-icon>delete</mat-icon>
              Delete files
            </button>
            <button mat-menu-item type="button" [matMenuTriggerFor]="select">
              <mat-icon>checklist</mat-icon>
              Select
            </button>
            <button (click)="openSelected()" mat-menu-item type="button" [disabled]="Checked.length === 0">
              <mat-icon>open_in_new</mat-icon>
              Open {{Checked.length}} files
            </button>
            <button (click)="downloadSelected()" mat-menu-item type="button" [disabled]="Checked.length === 0">
              <mat-icon>cloud_download</mat-icon>
              Download {{Checked.length}} files
            </button>
            <button (click)="copyToClipboard(currentDirectory.Path)" *ngIf="currentDirectory" mat-menu-item
                    type="button">
              <mat-icon>file_copy</mat-icon>
              Copy path
            </button>
            <button mat-menu-item (click)="showThumbnails = !showThumbnails">
              <mat-icon>{{showThumbnails ? 'list' : 'apps'}}</mat-icon>
              {{showThumbnails ? 'List view' : 'Grid view'}}
            </button>
          </mat-menu>
          <mat-menu #select="matMenu">
            <button (click)="this.Checked = currentDirectory.Children" mat-menu-item type="button">Alles</button>
            <button (click)="this.Checked = []" mat-menu-item type="button">Niets</button>
          </mat-menu>
        </mat-toolbar-row>
      </mat-toolbar>
    </div>
  </div>
  <!--list view-->
  <div class="row">
    <div class="col-md-3 set-font">
      <ng-template #recursiveList let-list>
        <li *ngFor="let item of list">
          <ng-container *ngIf="item.Type === 'd'">
            <mat-icon>
              {{item.IsOpen ? 'folder_open' : 'folder'}}
            </mat-icon>
            <a (click)="setCurrentDirectory(item);"
               matTooltip="{{item.Children.length}} files">{{item.Name}}</a>
            <ul *ngIf="item.Children.length > 0 && item.IsOpen">
              <ng-container
                *ngTemplateOutlet="recursiveList; context:{ $implicit: item.Children }"></ng-container>
            </ul>
          </ng-container>
        </li>
      </ng-template>

      <ul class="directories">
        <ng-container
          *ngTemplateOutlet="recursiveList; context:{ $implicit: rootAttachment?.Children }"></ng-container>
      </ul>
    </div>
    <div *ngIf="!showThumbnails && currentDirectory?.Children.length > 0" class="col-md-9">
      <mat-list>
        <mat-list-item *ngFor="let file of currentDirectory?.Children">
          <mat-icon matListItemIcon>{{ file.Type === 'd' ? 'folder' : 'file_copy' }}</mat-icon>
          <span matListItemTitle>
            <a (click)="setCurrentDirectory(file)" *ngIf="file.Type === 'd'">{{ file.Name }}</a>
            <span *ngIf="file.Type !== 'd'">{{ file.Name }}</span>
          </span>

          <ng-container *ngIf="file.Type !== 'd'" matListItemMeta>
            <mat-checkbox (change)="toggleCheck($event, file)" [disabled]="disableCheckbox(file)"
                          [checked]="isChecked(file)"></mat-checkbox>
            <button [matMenuTriggerData]="{attachment: file}" [matMenuTriggerFor]="actionsMenu" mat-icon-button>
              <mat-icon>more_vert</mat-icon>
            </button>
          </ng-container>
        </mat-list-item>
      </mat-list>
      <mat-menu #actionsMenu="matMenu">
        <ng-template let-attachment="attachment" matMenuContent>
          <button (click)="openAttachment(attachment)" mat-menu-item type="button">
            <mat-icon>open_in_new</mat-icon>
            Open {{attachment.Name}}
          </button>
          <button (click)="downloadAttachment(attachment)" mat-menu-item type="button">
            <mat-icon>cloud_download</mat-icon>
            Download
          </button>
          <button (click)="deleteAttachment(attachment)" mat-menu-item type="button">
            <mat-icon>delete</mat-icon>
            Delete file
          </button>
        </ng-template>
      </mat-menu>
    </div>
    <!--thumbnail view-->
    <div *ngIf="showThumbnails && currentDirectory?.Children.length > 0" class="col-md-9">
      <div class="row d-flex flex-wrap justify-content-around align-items-start" style="margin-top: 20px">
        <ng-container *ngFor="let file of currentDirectory?.Children">
          <div class="thumbnail"
               style="display:inline-block; text-align:center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
               matTooltip="{{file.Name}} {{file.Date | date:'short'}}, {{file.Size / 1000 | number}} kB}}">
            <div class="row thumbnail-content">
              <div class="col-md-12">
                <img *ngIf="file.Type?.includes('image'); else noimg" alt="" src="{{_Global.getImage(file.Path)}}"
                     style="height: 100px" class="vertical-center">
                <ng-template #noimg>
                  <mat-icon class="vertical-center">{{file.Type === 'd' ? 'folder' : 'file_copy'}}</mat-icon>
                </ng-template>
              </div>
            </div>
            <div class="thumbnail-content set-font">
              <div class="row">
                <div class="col-md-12">
                  <a (click)="setCurrentDirectory(file)"
                     *ngIf="file.Type === 'd'">{{file.Name}}</a>
                  <span *ngIf="file.Type !== 'd'">{{file.Name}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <ng-container *ngIf="file.Type !== 'd'">
                    <mat-checkbox (change)="toggleCheck($event, file)" [checked]="isChecked(file)"></mat-checkbox>
                    <button [matMenuTriggerData]="{attachment: file}" [matMenuTriggerFor]="actionsMenu"
                            mat-icon-button>
                      <mat-icon>more_vert</mat-icon>
                    </button>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div *ngIf="currentDirectory?.Children.length === 0" class="col-md-9">
      <p>Oops, directory is empty.</p>
    </div>
    <mat-menu #actionsMenu="matMenu">
      <ng-template let-attachment="attachment" matMenuContent>
        <button (click)="openAttachment(attachment)" mat-menu-item type="button">
          <mat-icon>open_in_new</mat-icon>
          Open in new window {{attachment.Name}}
        </button>
        <button (click)="downloadAttachment(attachment)" mat-menu-item type="button">
          <mat-icon>cloud_download</mat-icon>
          Download
        </button>
        <button (click)="deleteAttachment(attachment)" mat-menu-item type="button">
          <mat-icon>delete</mat-icon>
          Delete file
        </button>
      </ng-template>
    </mat-menu>
  </div>
</ng-container>
